<template>
  <FilterBar
    class="team-filter-bar"
    :is-loading="loading"
  >
    <template #prefilter>
      <FilterSearch
        :active-search="activeSearch"
        :loading="loading"
        @update-search="updateTeams({ ...$event, router: $router })"
        @set-page="setPageNumber(1)"
      />
    </template>
    <template #submenu>
      <div class="d-flex align-center">
        <v-btn
          class="ml-2 action-button"
          elevation="0"
          height="32"
          width="44"
          min-width="44"
          :disabled="!displayableTeamList.length || downloading"
          @click="handleDownload"
        >
          <DpplPageLoader
            v-if="downloading"
            :size="15"
            :width="2"
          />
          <DownloadArrow v-else />
        </v-btn>
      </div>
    </template>
  </FilterBar>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppPagination } from '@/stores/app/pagination';
import { useFilters } from '@/stores/filters/filters';
import { useSettingsTeam } from '@/stores/settings/team';
import { useTracking } from '@/stores/tracking/tracking';
import FilterBar from '@/components/filter/FilterBar.vue';
import DpplPageLoader from '@/components/datapeople/DpplPageLoader.vue';
import FilterSearch from '@/components/filter/filterMenu/FilterSearch.vue';
import DownloadArrow from '@/assets/icon-download-arrow.svg?component';

export default {
  name: 'TeamFilterBar',
  components: {
    FilterBar,
    FilterSearch,
    DownloadArrow,
    DpplPageLoader,
  },
  props: {
    activeSearch: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      downloading: false,
    };
  },
  computed: {
    ...mapState(useSettingsTeam, ['displayableTeamList']),
    ...mapState(useAppAuthData, ['authData']),
    ...mapState(useFilters, ['mergedTempFilters']),
    projectName() { return this.authData.projectName; },
  },
  methods: {
    ...mapActions(useSettingsTeam, ['downloadTeam', 'updateTeamsView']),
    ...mapActions(useAppPagination, ['setPageNumber']),
    async handleDownload() {
      this.downloading = true;

      await this.downloadTeam(
        `${this.projectName.toLowerCase()}-team.csv`,
        this.mergedTempFilters,
      );

      this.downloading = false;
    },
    updateTeams(event) {
      useTracking().teamsViewUpdated(event);
      this.updateTeamsView({
        ...event,
        routeQuery: this.$route.query,
      });
    },
  },
};
</script>

<style scoped lang="less">
.team-filter-bar {
  margin-bottom: 12px;

  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  .action-button.v-btn {
    background: @white;

    &:hover {
      background: @bg-canvas;
    }

    :deep(.v-btn__overlay), :deep(.v-btn__underlay) {
      background: none;
    }
  }
}
</style>
